import React from 'react';
import { FadeIn, SlideInLeft } from './ScrollReveal';

const CustomerReferences = () => {
  const customers = [
    {
      id: 1,
      name: 'OUTFIT',
      logo: '/images/Partner/logo-outfit.png',
      description: 'Professionelle Fliesenverlegung erfolgreich realisiert'
    }
  ];

  return (
    <section id="customer-references" className="py-16" style={{ backgroundColor: '#0193dd' }}>
      <div className="max-w-6xl mx-auto px-6">
        <FadeIn>
          <div className="text-center mb-12">
            <h2 className="text-3xl lg:text-4xl font-light text-white mb-4 tracking-wide">
              Unsere zufriedenen Kunden
            </h2>
            <p className="text-lg text-blue-100 font-light leading-relaxed max-w-2xl mx-auto">
              Vertrauen Sie auf unsere Erfahrung und Qualität - unsere Kunden bestätigen es.
            </p>
          </div>
        </FadeIn>

        <SlideInLeft>
          <div className="flex justify-center">
            <div className="grid grid-cols-1 md:grid-cols-3 gap-12 max-w-5xl">
              {customers.map((customer) => (
                <div 
                  key={customer.id}
                  className="text-center"
                >
                  <div className="h-24 flex items-center justify-center mb-6 bg-white/10 p-6 rounded-lg backdrop-blur-sm">
                    <img 
                      src={customer.logo} 
                      alt={`${customer.name} Logo`}
                      className="max-h-16 max-w-full object-contain brightness-0 invert"
                    />
                  </div>
                  <h3 className="text-xl font-medium text-white mb-3">
                    {customer.name}
                  </h3>
                  <p className="text-blue-100 font-light">
                    {customer.description}
                  </p>
                </div>
              ))}
              
              {/* Placeholder für weitere Kunden */}
              <div className="text-center opacity-70">
                <div className="h-24 flex items-center justify-center mb-6 bg-white/10 p-6 rounded-lg backdrop-blur-sm border-2 border-dashed border-white/30">
                  <span className="text-white/60 text-sm">Wird bald veröffentlicht</span>
                </div>
                <h3 className="text-xl font-medium text-white mb-3">
                  Weitere Referenz
                </h3>
                <p className="text-blue-100 font-light">
                  Kommt in Kürze
                </p>
              </div>
              
              <div className="text-center opacity-70">
                <div className="h-24 flex items-center justify-center mb-6 bg-white/10 p-6 rounded-lg backdrop-blur-sm border-2 border-dashed border-white/30">
                  <span className="text-white/60 text-sm">Wird bald veröffentlicht</span>
                </div>
                <h3 className="text-xl font-medium text-white mb-3">
                  Weitere Referenz
                </h3>
                <p className="text-blue-100 font-light">
                  Kommt in Kürze
                </p>
              </div>
            </div>
          </div>
        </SlideInLeft>
      </div>
    </section>
  );
};

export default CustomerReferences;
